// Firebase Hosting's registered web configuration; native apps retain their existing identity.
export function firebasePlatformConfig(native: boolean) {
  if (process.env.REACT_APP_FINFLOW_ENVIRONMENT === 'staging') {
    if (native) throw new Error('Native staging requires separately provisioned Firebase native resources');
    const config = JSON.parse(process.env.REACT_APP_FIREBASE_CONFIG || '{}');
    for (const key of ['apiKey','appId','projectId','authDomain','storageBucket','messagingSenderId']) {
      if (typeof config[key] !== 'string' || !config[key]) throw new Error('Complete staging Firebase configuration required');
    }
    const project = config.projectId;
    const approvedCustomHost = project === 'finflowtechs-staging' ? 'staging.finflowfinance.com' : null;
    if (!/^[a-z][a-z0-9-]{4,28}[a-z0-9]$/.test(project) ||
        ['finflowtechs','finflowfinance','finflow-play-services'].includes(project) ||
        ![`${project}.firebaseapp.com`, approvedCustomHost].includes(config.authDomain) ||
        ![`${project}.firebasestorage.app`, `${project}.appspot.com`].includes(config.storageBucket)) {
      throw new Error('Production or mismatched Firebase resources cannot be used for staging');
    }
    const api = new URL(process.env.REACT_APP_API_BASE_URL || '');
    if (api.protocol !== 'https:' || api.username || api.password || api.port ||
        ![`${project}.web.app`, `us-central1-${project}.cloudfunctions.net`, approvedCustomHost].includes(api.hostname)) {
      throw new Error('Explicit staging API required');
    }
    return config as {apiKey:string;appId:string;projectId:string;authDomain:string;storageBucket:string;messagingSenderId:string;measurementId?:string};
  }
  return {
    apiKey: native ? 'AIzaSyC6jPX5lRYQN6Uq9b_PQ1yFrmCUgSEudME' : 'AIzaSyDcJs5FllSh4uENcdAMjMOvuYdVR2zYt5w',
    appId: native ? '1:246153428025:ios:69e2a00363da732bdfe1e8' : '1:246153428025:web:f06772b3c9c53d43dfe1e8',
    authDomain: 'finflowfinance.com',
    projectId: 'finflowtechs',
    storageBucket: 'finflowtechs.firebasestorage.app',
    messagingSenderId: '246153428025',
    measurementId: 'G-PND93MHLRB'
  };
}
